/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Frame_Rate_HelpInputs */



/**
* | output |
* | --- |
* | "Select the frame rate of your target material" |
*
* @param {Target_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_frame_rate_help = /** @type {((inputs?: Target_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez la fréquence d’images de votre cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Bildrate Ihres Zielmaterials.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la frequenza dei fotogrammi del materiale di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите частоту кадров целевого материала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione la velocidad de fotogramas de su material de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择目标素材的帧速率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象素材のフレームレートを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी लक्षित सामग्री की फ्रेम दर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a taxa de quadros do seu material de destino.")
	return /** @type {LocalizedString} */ ("Select the frame rate of your target material")
});